<template>
  <div class="notice" :style="{'paddingTop': statusBar + 'rem'}" ref="getheigh">
    <Headerd title="客服" :back="true" left="返回" :white="true" />
    <div class="noticemain" ref="getheight">
      <iframe class="kefu" :src='url' frameborder="0"></iframe>

    </div>
  </div>
</template>

<script>
import Headerd from "@/components/Headerd";
export default {
  name: "notice",
  /**
   * 初始化数据
   */
  data() {
    return {
      url: "http://webchattest.singlewindow.cn/",
      statusBar: 0,
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);

    console.log(window.scrollY);
  },
  updated() {
    /**
     * 页面加载完毕后Y轴置在最顶端
     * bug出现形式未知
     */
    window.scroll(0, 0);
    console.log("nextTick " + window.scrollY);
  },

  /**
   * 方法
   */
  methods: {},

  components: {
    Headerd,
  },
};
</script>

<style scoped lang="scss">
.notice {
  //width: 100%;
  background: #f7f8fa;
  .noticemain {
    overflow: auto;
    background: #fff;
    .kefu {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>